import { render } from "./product.vue?vue&type=template&id=9607c6d2&scoped=true"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"

import "./product.vue?vue&type=style&index=0&id=9607c6d2&lang=css"
import "./product.vue?vue&type=style&index=1&id=9607c6d2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9607c6d2"]])

export default __exports__